import { useAppDispatch } from "@/stores/hook";
import { clearConversation, closePanel } from "../stores/aiChatSlice";
import ModelPicker from "./ModelPicker";
import { LanguageToggle, VoiceHeaderToggles } from "./VoiceControls";

// ---------------------------------------------------------------------------
// AIPanelHeader — two rows so nothing ever clips at the panel's 400 px:
//   row 1: ✨ Xale AI                          [ml/en]  Clear  ×
//   row 2: [model ▾ (takes the rest)] [Voice] [Telecaller] [read aloud]
// The old single row overflowed as soon as a second voice control existed
// (title wrapped, right-hand buttons cut off). Row 2 may wrap on very
// narrow viewports instead of hiding anything.
// ---------------------------------------------------------------------------

export default function AIPanelHeader() {
  const dispatch = useAppDispatch();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 8,
        padding: "10px 12px",
        borderBottom: "1px solid var(--color-black-3, #e5e7eb)",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0, whiteSpace: "nowrap" }}>
          <span style={{ fontSize: 16, lineHeight: 1 }}>✨</span>
          <strong style={{ fontSize: 14 }}>Xale AI</strong>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 6, flex: "none" }}>
          <LanguageToggle />
          <button
            onClick={() => dispatch(clearConversation())}
            title="Clear conversation"
            style={{
              background: "transparent",
              border: "1px solid var(--color-black-3, #e5e7eb)",
              borderRadius: 6,
              padding: "4px 8px",
              cursor: "pointer",
              fontSize: 11,
              color: "var(--color-text-secondary, #555)",
              whiteSpace: "nowrap",
            }}
          >
            Clear
          </button>
          <button
            onClick={() => dispatch(closePanel())}
            aria-label="Close"
            style={{
              background: "transparent",
              border: 0,
              cursor: "pointer",
              fontSize: 18,
              lineHeight: 1,
              padding: "0 4px",
              color: "var(--color-text-secondary, #555)",
            }}
          >
            ×
          </button>
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap", minWidth: 0 }}>
        {/* The model select takes what is left and truncates its label. */}
        <div style={{ flex: "1 1 140px", minWidth: 0, display: "flex" }}>
          <ModelPicker />
        </div>
        <VoiceHeaderToggles withLanguage={false} />
      </div>
    </div>
  );
}
